module.exports = __webpack_public_path__ + "img/HP-icon-footer.9d23cc7a.svg";